import { render, staticRenderFns } from "./LayoutProyecto.vue?vue&type=template&id=516480f8"
import script from "./LayoutProyecto.vue?vue&type=script&lang=js"
export * from "./LayoutProyecto.vue?vue&type=script&lang=js"
import style0 from "./LayoutProyecto.vue?vue&type=style&index=0&id=516480f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports